export default __webpack_public_path__ + "static/media/pause_circle_filled.f73ccc39.svg";